import { render, staticRenderFns } from "./MyInfoPersonalAgreeChoicePop.vue?vue&type=template&id=f2be419e&scoped=true"
import script from "./MyInfoPersonalAgreeChoicePop.vue?vue&type=script&lang=js"
export * from "./MyInfoPersonalAgreeChoicePop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2be419e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f2be419e')) {
      api.createRecord('f2be419e', component.options)
    } else {
      api.reload('f2be419e', component.options)
    }
    module.hot.accept("./MyInfoPersonalAgreeChoicePop.vue?vue&type=template&id=f2be419e&scoped=true", function () {
      api.rerender('f2be419e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/user/popup/MyInfoPersonalAgreeChoicePop.vue"
export default component.exports